import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "../Header/Header";
import Provider from "../Provider/Provider";
import SearchBar from "../SearchBar/SearchBar";
import UserCard from "../UserCard/UserCard";
import { lightTheme, darkTheme } from "../Provider/theme";
import Skeleton from "../Skeleton/Skeleton";

const Wrapper = styled.div`
  width: 50%;
  margin: auto;
  margin-top: 100px;

  @media only screen and (max-width: 768px) {
    width: 90%;
    margin-top: 50px;
  }
`;
function App() {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState("KarthikGH07");
  const [isThemeDark, setIsThemeDark] = useState(true);

  const fetchUser = async () => {
    setIsLoading(true);
    const res = await axios.get(`https://api.github.com/users/${query}`);
    setData(res.data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <Provider theme={isThemeDark ? darkTheme : lightTheme}>
      <Wrapper>
        <Header isThemeDark={isThemeDark} setIsThemeDark={setIsThemeDark} />
        <SearchBar handleSearch={fetchUser} setQuery={setQuery} />
        {isLoading ? <Skeleton /> : <UserCard user={data} />}
      </Wrapper>
    </Provider>
  );
}

export default App;
